import * as Yup from 'yup';
import { requiredField } from 'utils/string';
import { t } from 'utils/i18n';
import { validatePhone } from 'utils/validators';

export const initialValues = {
  contract: null,
  phone: '',
  name: null,
  amount: 0,
  due: null,
  comment: '',
};

export const validationSchema = Yup.object().shape({
  contract: Yup.object()
    .shape({
      id: Yup.string(),
      name: Yup.string(),
    })
    .nullable()
    .required(requiredField('contract')),
  name: Yup.object()
    .shape({
      id: Yup.string(),
      name: Yup.string(),
    })
    .nullable()
    .required(requiredField('contactPerson')),
  phone: Yup.string()
    .required(requiredField('phone'))
    .test(
      'check phone rules ',
      t('wrongPhoneFormat'),
      function testPhone(value) {
        return validatePhone(value);
      },
    ),
  amount: Yup.string().required(requiredField('amount')),
  due: Yup.string().nullable().required(requiredField('due')),
  comment: Yup.string().required(requiredField('comment')),
});
